<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.46572 23.28H21.1165C23.8615 23.2815 26.1444 21.168 26.3542 18.431C26.5639 15.6939 24.6298 13.2573 21.9166 12.8404C21.4631 11.0416 20.4298 9.44223 18.9764 8.28942C17.4963 7.11052 15.6583 6.47191 13.7661 6.47906C10.7315 6.48281 7.93375 8.11919 6.44297 10.7623C3.2041 11.2931 0.915302 14.2216 1.18257 17.4927C1.44984 20.7639 4.18364 23.282 7.46572 23.28ZM10.1371 15.4664L13.7505 19.0798L17.3639 15.4664C17.5805 15.2498 17.4271 14.8796 17.1208 14.8796H15.2731V12.8752C15.2731 12.2424 14.7601 11.7294 14.1273 11.7294H13.3738C12.7409 11.7294 12.2279 12.2424 12.2279 12.8752V14.8796H10.3802C10.0739 14.8796 9.92055 15.2498 10.1371 15.4664Z"
            fill="#3E8DFF" />
    </svg>
</template>

<script>
export default {
    name: 'DownloadIcon'
}
</script>